import { render } from "./New.vue?vue&type=template&id=1328711e"
const script = {}

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__